"use client";
import { useState, useEffect } from "react";

export interface ScrollPosition {
  x: number;
  y: number;
}

type CallbackFunction = (scrollPosition: ScrollPosition) => void;

type FetchMoreFunction = () => void;

export const useScroll = (
  ref: React.RefObject<HTMLDivElement | null>,
  threshold: number,
  callback?: CallbackFunction,
  fetchMoreFunction?: FetchMoreFunction,
): void => {
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const refCurrent = ref.current;
    const handleScroll = async () => {
      if (!refCurrent) return;
      const { scrollTop } = refCurrent;
      const scrollPosition: ScrollPosition = {
        x: refCurrent.scrollLeft,
        y: scrollTop,
      };
      if (callback) callback(scrollPosition);
      if (scrollTop <= threshold && fetchMoreFunction && !isFetching) {
        setIsFetching(true);

        try {
          await fetchMoreFunction();
        } catch (error) {
          // console.error(error);
        } finally {
          setIsFetching(false);
        }
      }
    };

    if (refCurrent) {
      refCurrent.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, [ref, callback, threshold, fetchMoreFunction, isFetching]);
};
